var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('application-settings',{attrs:{"initApp":_vm.app,"mode":_vm.mode,"copied":_vm.modeArg === 'copy'}})}
var staticRenderFns = []

export { render, staticRenderFns }